import type { ReactNode } from 'react';

import { Dialog, DialogContent, DialogDescription, DialogTitle } from './ui/dialog';

/** Diálogo controlado con título y descripción. */
export function Modal({
  abierto,
  onCerrar,
  titulo,
  descripcion,
  ancho = 'max-w-lg',
  children,
}: {
  abierto: boolean;
  onCerrar: () => void;
  titulo: string;
  descripcion?: string;
  ancho?: string;
  children: ReactNode;
}) {
  return (
    <Dialog open={abierto} onOpenChange={(o) => !o && onCerrar()}>
      <DialogContent className={ancho}>
        <DialogTitle>{titulo}</DialogTitle>
        {descripcion ? (
          <DialogDescription>{descripcion}</DialogDescription>
        ) : (
          <DialogDescription className="sr-only">{titulo}</DialogDescription>
        )}
        <div className="mt-5">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
